import React from 'react';
import { Box, BoxProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  section: {
    backgroundImage: `url('/images/section_header.png')`,
    backgroundPositionX: 'center',
    backgroundRepeat: 'no-repeat',
    margin: '0px 0px 16px',
    padding: '48px 0px',
  },
});

const Section: React.FC<BoxProps> = ({ children, ...props }) => {
  const { section } = useStyles();
  return (
    <Box className={section} {...props}>
      {children}
    </Box>
  );
};

export default Section;
